<template>
  <div class="x-tag-cloud">
    <div
      v-for="tag in tags"
      :key="`${id}-${tag.id}`"
      class="tag-item"
    >
      <input
        :id="`${id}-${tag.id}`"
        v-model="checked"
        class="tag-input"
        :type="type"
        :value="tag.id"
        :name="id"
      >

      <label
        class="tag-label"
        :for="`${id}-${tag.id}`"
      >
        {{ tag.name }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'XTagCloud',

  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: [Array, String, Number],
      default: null
    },
    tags: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: function (value) {
        return ['checkbox', 'radio'].indexOf(value) !== -1
      }
    }
  },

  data () {
    return {
      checked: this.value
    }
  },

  watch: {
    value: function (nVal) {
      this.checked = nVal
    },

    checked: function () {
      this.$emit('input', this.checked)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/styles/vars.scss';

  .x-tag-cloud {
    .tag-item {
      display: inline-block;
      margin-right: $space-medium;
      margin-bottom: $space-medium;
      user-select: none;
    }

    .tag-label {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0.4rem;
      background-color: #EBEDF8;
      padding: 0.7rem 1.4rem;
      border: 0.1rem solid #EBEDF8;
      font-weight: 600;
      color: $color-daddy;
      font-size: 1.3rem;
      cursor: pointer;
      text-transform: uppercase;
    }

    .tag-input {
      display: none;
    }

    .tag-input:checked+.tag-label {
      border: 0.1rem solid map_get($palette-primary, main);
      background-color: rgba(map_get($palette-primary, main), 0.12);
      color: map_get($palette-primary, main);
    }
  }
</style>